import{j as o,k as r}from"./chunk-GTEBSQTL.mjs";var m=new o({locale:r});export{m as a};
